var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cultureStoryDetailYoutubeCard"},[_c('div',{staticClass:"embed-container",attrs:{"alt":`${_vm.item.title}`}},[_c('iframe',{attrs:{"src":_vm.youtubeURL,"frameborder":"0","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }